export async function getContentType(
  attachmentId: string,
): Promise<'image' | 'video' | 'audio' | 'pdf' | 'unknown'> {
  try {
    const apiHost = 'https://app.brainfi.sh';

    const response = await fetch(
      `${apiHost}/api/attachments.public.contentType?id=${attachmentId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    ).then((res) => res.json());

    if (!response.ok) {
      return 'unknown';
    }

    const contentType = response.contentType as string;

    if (contentType?.startsWith('image/')) {
      return 'image';
    }
    if (contentType?.startsWith('video/')) {
      return 'video';
    }
    if (contentType?.startsWith('audio/')) {
      return 'audio';
    }
    if (contentType?.startsWith('application/pdf')) {
      return 'pdf';
    }

    return 'unknown';
  } catch (error) {
    return 'unknown';
  }
}
